const { objectOperator } = require('../agent/utils/spread');
const commons = require('./commons');
const {
  WINDOW_DOM,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
  RAM_SIZE,
  CPU_CORES,
  USER_AGENT,
  DARK_MODE,
  REDUCED_MOTION,
  REDUCED_COLOR,
  APP_NAME,
  SCOPE_NAME,
  DEVICE,
  PLATFORM_ID,
  SITE_ID,
  WEBVIEW,
  REQUEST_ID,
  VIEW_NAME,
} = require('./metrics');

const metrics = [
  WINDOW_DOM,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
  RAM_SIZE,
  CPU_CORES,
  USER_AGENT,
  DARK_MODE,
  REDUCED_MOTION,
  REDUCED_COLOR,
  URL,
  APP_NAME,
  SCOPE_NAME,
  DEVICE,
  PLATFORM_ID,
  SITE_ID,
  WEBVIEW,
  REQUEST_ID,
  VIEW_NAME,
];

const RRWEB_EVENT_TYPES = {
  DomContentLoaded: 0,
  Load: 1,
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Custom: 5,
};

const MAX_PAYLOAD_SIZE = 1000 * 1000; // 1 MB
const PAYLOAD_SIZE = MAX_PAYLOAD_SIZE - 1000; // 1000 bytes for metadata
const MAX_MLDATA_WAITING_TIME = 3000; // 3s
const CHUNKS_EXPIRATION_TIME = 1000 * 60 * 4; // 4 hours
const MAX_FLUSH_TIME = 1000 * 30; // 30s
const MAX_CHUNKS_SIZE = 50;

module.exports = objectOperator([commons, {
  endpoint: (location) => `__events_domain__/v1/media-storage-service/session-replay-store-${location}/assets`,
  RRWEB_EVENT_TYPES,
  MAX_PAYLOAD_SIZE,
  PAYLOAD_SIZE,
  MAX_MLDATA_WAITING_TIME,
  CHUNKS_EXPIRATION_TIME,
  MAX_CHUNKS_SIZE,
  MAX_FLUSH_TIME,
}, { metrics }]);
